<div class="home-container">
    <div class="home-page">
        <div class="disclaimer">
            <h2>Disclaimer</h2>

            <p>
                Access to this system is for authorized users only and expresses consent for no expectation to privacy and to the following declared actions.
                The company owns all systems and data. Monitoring, intercepting, recording, copy and disclosure of data in any manner by authorized
                company personnel may occur.
            </p>

            <p>
                Unauthorized or improper use of this system may result in administrative, disciplinary action, civil and criminal
                penalties. Additionally, by signing in, you acknowledge that you have read and agree to the terms outlined in the disclaimer.
            </p>

            <button *ngIf="isAuthenticated" (click)="logout($event)">
                Sign Out
            </button>

            <button *ngIf="!isAuthenticated" (click)="login($event)">
                Sign In
            </button>
        </div>
    </div>
</div>